import _ from 'lodash';
import { sqReportStore } from '@/core/core.stores';
import { ContentTypes } from '@/dashboard/dashboard.types';
import { getWorkbooksLink, goTo } from '@/main/routing.utilities';
import { manageLoadedReportContent, removeContent } from '@/reportEditor/report.actions';
import { doTrack } from '@/track/track.service';
import { errorToast } from '@/utilities/toast.utilities';
import { sqAnnotationsApi } from '@seeqdev/api/endpoint/AnnotationsApi';
import { sqContentApi } from '@seeqdev/api/endpoint/ContentApi';

export async function loadDashboard(dashboardId: string) {
  try {
    const [{ data: report }, { data }] = await Promise.all([
      sqAnnotationsApi.getAnnotation({ id: dashboardId }),
      sqContentApi.getContentsWithAllMetadata({ reportId: dashboardId }),
    ]);
    manageLoadedReportContent(report, data, false);
    doTrack('Topic', 'Dashboard loaded', `${_.size(data?.contentItems)} content pieces added to dashboard`);
  } catch (response) {
    // CRAB-20279: If report content fails to load, show the error to the user and go home.
    errorToast({ httpResponseOrError: response });
    goTo(getWorkbooksLink());
  }
}

export function saveDashboardTextTile(id: string, interests: string[], document: string) {
  return sqAnnotationsApi.updateAnnotation(
    {
      name: 'ignored',
      document,
      interests: interests.map((interest) => ({
        interestId: interest,
      })),
    },
    { id },
  );
}

/**
 * Removes a dashboard tile and its backing content. The dashboard tile is removed via the supplied
 * `removeFromDashboard` callback (the Dashboard store's `removeContent` action), and the underlying
 * report content or annotation is cleaned up based on the tile's content type.
 */
export function removeDashboardItem(id: string, contentType: ContentTypes, removeFromDashboard: (id: string) => void) {
  removeFromDashboard(id);
  if (contentType === ContentTypes.Visual) {
    return removeContent(sqReportStore.getContentById(id)!, true);
  }
  if ([ContentTypes.Text, ContentTypes.Markdown].includes(contentType)) {
    return sqAnnotationsApi.archiveAnnotation({ id });
  }
}
